import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiStripepaymentgatewayGetCardDetailQueryResponse,
  GetApiStripepaymentgatewayGetCardDetailQueryParams,
  GetApiStripepaymentgatewayGetCardDetail401,
  GetApiStripepaymentgatewayGetCardDetail403,
} from "../../../types/GetApiStripepaymentgatewayGetCardDetail";

export function getGetApiStripepaymentgatewayGetCardDetailUrl() {
  return `/api/StripePaymentGateway/get-card-detail` as const;
}

/**
 * {@link /api/StripePaymentGateway/get-card-detail}
 */
export async function getApiStripepaymentgatewayGetCardDetail(
  params?: GetApiStripepaymentgatewayGetCardDetailQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiStripepaymentgatewayGetCardDetailQueryResponse,
    ResponseErrorConfig<
      | GetApiStripepaymentgatewayGetCardDetail401
      | GetApiStripepaymentgatewayGetCardDetail403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiStripepaymentgatewayGetCardDetailUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
